(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('DOMContentLoaded', function () {
    /* Header: shadow on scroll, back to top */
    var header = $('[data-header]'), top = $('[data-to-top]');
    function onScroll() {
      var y = window.scrollY;
      if (header) header.classList.toggle('scrolled', y > 20);
      if (top) top.classList.toggle('show', y > 600);
    }
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

    /* Drawer */
    var drawer = $('[data-drawer]'), scrim = $('[data-scrim]'), openBtn = $('[data-drawer-open]');
    function setDrawer(on) {
      if (!drawer) return;
      drawer.classList.toggle('open', on); scrim.classList.toggle('on', on);
      if (openBtn) openBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
    var closeBtn = $('[data-drawer-close]'); if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });

    /* Search panel */
    var panel = $('[data-search-panel]'), sInput = $('[data-search-input]');
    function setSearch(on) {
      if (!panel) return;
      panel.hidden = false; panel.classList.toggle('open', on); scrim.classList.toggle('on', on);
      if (on && sInput) setTimeout(function () { sInput.focus(); }, 200);
    }
    var so = $('[data-search-open]'); if (so) so.addEventListener('click', function () { setSearch(true); });
    var sc = $('[data-search-close]'); if (sc) sc.addEventListener('click', function () { setSearch(false); });
    if (scrim) scrim.addEventListener('click', function () { setDrawer(false); setSearch(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setDrawer(false); setSearch(false); } });

    /* Announcement rotator */
    var rot = $('[data-rotator]');
    if (rot) {
      var msgs = $$('.ann-msg', rot), n = 0;
      if (msgs.length > 1) setInterval(function () {
        msgs[n].classList.remove('is-on'); n = (n + 1) % msgs.length; msgs[n].classList.add('is-on');
      }, 3800);
    }

    /* Scroll reveal */
    var items = $$('[data-reveal]');
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      items.forEach(function (el) { io.observe(el); });
    } else { items.forEach(function (el) { el.classList.add('in'); }); }

    /* Count up */
    var counters = $$('[data-count]');
    function runCount(el) {
      var raw = el.getAttribute('data-count'), end = parseFloat(raw.replace(/,/g, ''));
      if (isNaN(end) || reduce) return;
      var dec = parseInt(el.getAttribute('data-decimals') || '0', 10), t0 = null, suffix = raw.replace(/[0-9.,]/g, '');
      function step(t) {
        if (!t0) t0 = t; var p = Math.min((t - t0) / 1400, 1), v = end * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toFixed(dec) + suffix; if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if ('IntersectionObserver' in window) {
      var co = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { runCount(e.target); co.unobserve(e.target); } });
      }, { threshold: 0.6 });
      counters.forEach(function (c) { co.observe(c); });
    }

    /* Hero slider */
    $$('[data-slider]').forEach(function (s) {
      var slides = $$('.slide', s), dots = $$('.s-dot', s), i = 0, timer, secs = parseInt(s.getAttribute('data-autoplay') || '0', 10);
      if (secs) s.style.setProperty('--dur', secs + 's');
      function go(n) {
        slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        if (dots[i]) { void dots[i].offsetWidth; dots[i].classList.add('is-active'); }
        play();
      }
      function play() { clearTimeout(timer); if (secs && !reduce && slides.length > 1) timer = setTimeout(function () { go(i + 1); }, secs * 1000); }
      var p = $('[data-prev]', s), nx = $('[data-next]', s);
      if (p) p.addEventListener('click', function () { go(i - 1); });
      if (nx) nx.addEventListener('click', function () { go(i + 1); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      s.addEventListener('mouseenter', function () { clearTimeout(timer); s.classList.add('paused'); });
      s.addEventListener('mouseleave', function () { s.classList.remove('paused'); play(); });
      var x0 = null;
      s.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      s.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) go(dx < 0 ? i + 1 : i - 1); x0 = null;
      });
      play();
    });

    /* Reviews scroller */
    var track = $('[data-rev-track]');
    if (track) {
      var by = function (d) { var w = (track.firstElementChild ? track.firstElementChild.offsetWidth : 320) + 22; track.scrollBy({ left: d * w, behavior: 'smooth' }); };
      $('[data-rev-prev]').addEventListener('click', function () { by(-1); });
      $('[data-rev-next]').addEventListener('click', function () { by(1); });
      if (!reduce) setInterval(function () {
        if (track.matches(':hover')) return;
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 8) track.scrollTo({ left: 0, behavior: 'smooth' }); else by(1);
      }, 5000);
    }

    /* Countdown */
    $$('[data-countdown]').forEach(function (c) {
      var raw = c.getAttribute('data-countdown'), end = raw ? new Date(raw.replace(' ', 'T')).getTime() : NaN;
      function target() { if (!isNaN(end) && end > Date.now()) return end; var d = new Date(); d.setHours(23, 59, 59, 999); return d.getTime(); }
      var pad = function (n) { return String(n).padStart(2, '0'); };
      function tick() {
        var t = Math.max(target() - Date.now(), 0), q = function (s, v) { $(s, c).textContent = pad(v); };
        q('[data-d]', Math.floor(t / 864e5)); q('[data-h]', Math.floor(t / 36e5) % 24); q('[data-m]', Math.floor(t / 6e4) % 60); q('[data-s]', Math.floor(t / 1e3) % 60);
      }
      tick(); setInterval(tick, 1000);
    });

    /* Product page price swap */
    var select = $('[data-variant-select]'), price = $('[data-price]');
    if (select && price) select.addEventListener('change', function () {
      var v = select.options[select.selectedIndex].getAttribute('data-price'); if (v) price.textContent = v;
    });

    /* Ajax add to cart */
    var toast = $('[data-toast]');
    function say(msg) { if (!toast) return; toast.textContent = msg; toast.classList.add('show'); setTimeout(function () { toast.classList.remove('show'); }, 2600); }
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f.matches || !f.matches('[data-ajax-form]')) return;
      e.preventDefault();
      fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); });
          say('Added to cart');
        })
        .catch(function () { f.submit(); });
    });
  });
})();
